import { validate } from 'rut.js';
import { z } from 'zod';

export const representativeSchema = z.object({
  representative_email: z.string().email('El formato del email ingresado no es válido'),
  representative_rut: z.string().min(1, 'Este campo es requerido').refine((rut) => validate(rut), {
    message: 'El formato del RUT ingresado no es válido',
  }),
});

export type RepresentativeSchema = z.infer<typeof representativeSchema>;
